// extracted by mini-css-extract-plugin
export default {"pList":"CityList_pList__ILC9r","pListItem":"CityList_pListItem__X22OB","pListImg":"CityList_pListImg__-2eT9","pListTitles":"CityList_pListTitles__s5mJe"};